import { render, staticRenderFns } from "./ApproveCheckList.vue?vue&type=template&id=212c2553&"
import script from "./ApproveCheckList.vue?vue&type=script&lang=js&"
export * from "./ApproveCheckList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports